import React, { useState } from 'react';
import { OFFICE_LOCATIONS } from '../data/contact';
import { USA_OPENINGS } from '../data/careers';
import ApplyModal from '../components/ApplyModal';

const USA_OFFICE = OFFICE_LOCATIONS.find((office) => office.country === 'USA');
// Applications are now open for production. Automation is ready to process submissions.
const APPLICATIONS_CLOSED = false;

export default function UsaCareers() {
  const [expandedId, setExpandedId] = useState(null);
  const [applyJob, setApplyJob] = useState(null);

  return (
    <>
      {applyJob && <ApplyModal job={applyJob} onClose={() => setApplyJob(null)} />}
      <section className="section section-soft regional-careers-wrap">
        <div className="regional-careers-container">
          <div className="rc-intro">
            <div className="rc-intro-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="7" width="18" height="13" rx="2" />
                <path d="M8 7V5a4 4 0 0 1 8 0v2" />
              </svg>
            </div>
            <p>Explore our current job opportunities and take the next step in your career with TISSA Technology.</p>
          </div>

          {APPLICATIONS_CLOSED && (
            <div role="status" style={{ background: '#fff4e5', border: '1px solid #ffcc80', color: '#8a5300', padding: '14px 18px', borderRadius: 8, margin: '0 0 20px' }}>
              <strong>Applications are temporarily closed.</strong> We are not accepting new applications right now. Please check back soon.
            </div>
          )}

          <div className="careers-openings-grid">
            {USA_OPENINGS.map((job) => {
              const isOpen = expandedId === job.id;
              return (
                <article className="career-job-card" key={job.id}>
                  <div className="career-job-head">
                    <div>
                      <h3 className="career-job-title">{job.title}</h3>
                      <span className="career-job-idtag">ID: {job.id}</span>
                    </div>
                    <div className="career-job-head-right">
                      <span className="career-status">{job.status}</span>
                      <button
                        className="career-expand-btn"
                        onClick={() => setExpandedId(isOpen ? null : job.id)}
                        aria-expanded={isOpen}
                      >
                        {isOpen ? (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><polyline points="18 15 12 9 6 15"/></svg>
                        ) : (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="career-job-meta-row">
                    <span>{job.company}</span>
                    <span className="career-dot">·</span>
                    <span>{job.location}</span>
                    <span className="career-dot">·</span>
                    <span>{job.type}</span>
                    <span className="career-dot">·</span>
                    <span>{job.qualification}</span>
                  </div>

                  <p className="career-job-summary">{job.summary}</p>

                  {isOpen && (
                    <div className="career-job-expanded">
                      <div className="career-section">
                        <h4>Requirements</h4>
                        <p>{job.requirements}</p>
                      </div>
                      <div className="career-section">
                        <h4>Job Description</h4>
                        <p>{job.description}</p>
                      </div>
                      <div className="career-section">
                        <h4>Responsibilities</h4>
                        <ul className="career-resp-list">
                          {job.responsibilities.map((r, i) => (
                            <li key={i}>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#12683e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                              {r}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="career-section">
                        <h4>Required Skills</h4>
                        <div className="career-skills">
                          {job.skills.map((s) => (
                            <span className="career-skill-chip" key={s}>{s}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {APPLICATIONS_CLOSED ? (
                    <button className="career-apply-btn" disabled aria-disabled="true">
                      Applications Closed
                    </button>
                  ) : (
                    <button
                      className="career-apply-btn"
                      onClick={() => setApplyJob(job)}
                    >
                      Apply Now
                    </button>
                  )}
                </article>
              );
            })}
          </div>

          <section className="rc-block">
            <h3>Application Process</h3>
            <p>Open any active role, review details, and click Apply Now to submit your profile and resume directly to our HR inbox.</p>
            <div className="rc-address-box">
              <p><b>TISSA Technology LLC</b></p>
              <p>Human Resources Department</p>
              <p>{USA_OFFICE.careersLines[0]}</p>
              <p>{USA_OFFICE.careersLines[1]}</p>
            </div>
          </section>

          <div className="rc-contact-grid">
            <article className="rc-mini-card">
              <h4>Contact Us</h4>
              <p>For current openings, select a role, review requirements, and apply using the form above.</p>
              <p className="rc-readonly-email">We only review applications submitted through this portal.</p>
            </article>
            <article className="rc-mini-card">
              <h4>Our Location</h4>
              <p>
                TISSA Technology LLC<br />
                {USA_OFFICE.careersLines[0]}<br />
                {USA_OFFICE.careersLines[1]}
              </p>
            </article>
          </div>

          <section className="rc-block rc-why-join">
            <h3>Why Join TISSA Technology?</h3>
            <div className="rc-why-grid">
              <div>
                <h4>Innovative Projects</h4>
                <p>Work on cutting-edge technologies and challenging projects for Fortune 500 clients.</p>
              </div>
              <div>
                <h4>Growth Opportunities</h4>
                <p>Continuous learning and career advancement paths for ambitious professionals.</p>
              </div>
              <div>
                <h4>Collaborative Culture</h4>
                <p>Join a team that values collaboration, creativity, and technical excellence.</p>
              </div>
            </div>
            <p className="rc-closing-note">
              We&apos;re looking for talented individuals who are passionate about technology and ready to make an impact.
              If you&apos;re driven, innovative, and eager to grow, we want to hear from you!
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
